import React, { useState } from "react";
import { playMorseCodeAudio } from "../../utils/practicePage/MorseCodeGenerator";

const morseCodeDict = {
  A: ".-",
  B: "-...",
  C: "-.-.",
  D: "-..",
  E: ".",
  F: "..-.",
  G: "--.",
  H: "....",
  I: "..",
  J: ".---",
  K: "-.-",
  L: ".-..",
  M: "--",
  N: "-.",
  O: "---",
  P: ".--.",
  Q: "--.-",
  R: ".-.",
  S: "...",
  T: "-",
  U: "..-",
  V: "...-",
  W: ".--",
  X: "-..-",
  Y: "-.--",
  Z: "--..",
  0: "-----",
  1: ".----",
  2: "..---",
  3: "...--",
  4: "....-",
  5: ".....",
  6: "-....",
  7: "--...",
  8: "---..",
  9: "----.",
  "‘": ".----.",
  "“": ".-..-.",
  ":": "---...",
  ";": "-.-.-.",
  ",": "--..--",
  "/": "-..-.",
  "-": "-....-",
  "(": "-.--.",
  ")": "-.--.-",
  ".": ".-.-.-",
  "?": "..--..",
  "=": "-...-",
  "+": ".-.-.",
  "@": ".--.-.",
};

const MorseCodeVisualiser = ({ character }) => {
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const [isPlaying, setIsPlaying] = useState(false);
  const morseCode = morseCodeDict[character] || ""; // Prevents undefined error

  const handlePlay = () => {
    if (!morseCode) return; // Prevent errors for undefined Morse codes

    setIsPlaying(true);
    const symbols = morseCode.split("");
    let index = 0;
    const wpm = 4;

    const dotLength = (1.2 / wpm) * 1000;
    const dashLength = dotLength * 3;
    const spaceBetweenSymbols = dotLength;
    const spaceBetweenLetters = dotLength * 3;

    const highlightNext = () => {
      if (index < symbols.length) {
        setHighlightIndex(index);
        setTimeout(
          () => {
            setHighlightIndex(-1);
            index++;
            setTimeout(highlightNext, spaceBetweenSymbols);
          },
          symbols[index] === "." ? dotLength : dashLength
        );
      } else {
        setTimeout(() => {
          setHighlightIndex(-1);
          setIsPlaying(false);
        }, spaceBetweenLetters);
      }
    };

    playMorseCodeAudio([character], wpm, () => {
      setHighlightIndex(-1);
      setIsPlaying(false);
    });

    highlightNext();
  };

  return (
    <div className="morse-card">
      <h2 className="morseLetter">{character}</h2>
      <div className="morse-code">
        {morseCode.split("").map((symbol, index) => (
          <span
            key={index}
            className={`symbol ${symbol === "." ? "dot" : "dash"} ${
              highlightIndex === index ? "highlight" : ""
            }`}
          />
        ))}
      </div>
      <button
        className="tutorialButton"
        onClick={handlePlay}
        disabled={isPlaying}
      >
        Play
      </button>
    </div>
  );
};

export default MorseCodeVisualiser;
